import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from "./modules/layout/layout/layout.component";
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'child',
        loadChildren: () => import('./modules/child/child.module').then((m) => m.ChildModule),
      },
      {
        path: 'kindergarten',
        loadChildren: () => import('./modules/kindergarten/kindergarten.module').then((m) => m.KindergartenModule),
      },
      {
        path: 'games',
        loadChildren: () => import('./modules/games/games.module').then((m) => m.GamesModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/report/report.module').then((m) => m.ReportModule),
      },
      {
        path: 'user',
        loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'transition-report',
        loadChildren: () => import('./modules/transition-report/transition-report.module').then((m) => m.TransitionReportModule),
      },
    ],
  },
  { path: '**', component: NotFoundComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
